import { toast } from 'react-toastify'

const toasters = ({ type, message, duration }) => {
    switch (type) {
        case 'success':
            toast.success(message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: duration,
            })
            break
        case 'error':
            toast.error(message, {
                position: toast.POSITION.TOP_RIGHT,
            })
            break
        case 'warning':
            toast.warn(message, {
                position: toast.POSITION.TOP_RIGHT,
            })
            break
        case 'info':
            toast.info(message, {
                position: toast.POSITION.TOP_RIGHT,
            })
            break
        case 'custom':
            toast(message, {
                position: toast.POSITION.TOP_RIGHT,
                className: 'foo-bar',
            })
            break
        default:
            toast('Default Notification !')
    }
}

export default toasters
